const styles = theme => ({
  grid: {
    width: '100%',
    maxWidth: 610,
    flexBasis: 'unset',
    textAlign: 'center',
  },
  setPassword: {
    maxWidth: 752,
    margin: 'auto',
  },
})

export default styles
